module.exports = __webpack_public_path__ + "static/cabin-bold-e658dcb4c3dba1eef0f5de96d57c8f49.woff2";